function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1021 9C17.1021 11.7614 14.8178 14 12 14C9.18221 14 6.89794 11.7614 6.89794 9C6.89794 6.23858 9.18221 4 12 4C14.8178 4 17.1021 6.23858 17.1021 9ZM16.0025 14.7986C17.8976 13.5399 19.1429 11.4125 19.1429 9C19.1429 5.13401 15.9449 2 12 2C8.05509 2 4.85712 5.13401 4.85712 9C4.85712 11.4125 6.10243 13.5399 7.99745 14.7986C4.95595 16.0709 2.67337 18.7491 2 22H4.09388C5.0001 18.5495 8.19623 16 12 16C15.8038 16 18.9999 18.5495 19.9061 22H22C21.3266 18.7491 19.044 16.0709 16.0025 14.7986Z",
  fill: ""
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#220C4A",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.92ec3fb7.svg";
export { ForwardRef as ReactComponent };